module.exports = __webpack_public_path__ + "static/media/08.6f1153fc.jpg";